import moment from 'moment';
import DateUtil from '../utils/DateUtil';
import {TSSerializable} from './TSSerializable';
import {isInstanceOfHasUnconnectedDocuments} from './IHasUnconnectedDocuments';

export default class TSAbstractEntity {
    private _id: string;
    private _timestampErstellt: moment.Moment | undefined;
    private _timestampMutiert: moment.Moment | undefined;

    public set id(id: string) {
        this._id = id;
    }

    public set timestampErstellt(timestampErstellt: moment.Moment | undefined) {
        this._timestampErstellt = timestampErstellt;
    }

    public set timestampMutiert(timestampMutiert: moment.Moment | undefined) {
        this._timestampMutiert = timestampMutiert;
    }

    public get id(): string {
        return this._id;
    }

    public get timestampErstellt(): moment.Moment | undefined {
        return this._timestampErstellt;
    }

    public get timestampMutiert(): moment.Moment | undefined {
        return this._timestampMutiert;
    }

    public isNew(): boolean {
        return !this._timestampErstellt;
    }

    deserialize(restObject: any): TSAbstractEntity {
        this.id = restObject.id;
        this.timestampErstellt = DateUtil.localDateTimeToMoment(restObject.timestampErstellt);
        this.timestampMutiert = DateUtil.localDateTimeToMoment(restObject.timestampMutiert);
        if (isInstanceOfHasUnconnectedDocuments(this)) {
            this.documentIdsToConnect = restObject.documentIdsToConnect || [];
        }
        return this;
    }

    serialize(restObject: any): any {
        restObject.id = this.id;
        if (this.timestampErstellt) {
            restObject.timestampErstellt = DateUtil.momentToLocalDateTime(this.timestampErstellt);
        }
        if (this.timestampMutiert) {
            restObject.timestampMutiert = DateUtil.momentToLocalDateTime(this.timestampMutiert);
        }
        if (isInstanceOfHasUnconnectedDocuments(this) && this.documentIdsToConnect) {
            restObject.documentIdsToConnect = this.documentIdsToConnect;
        }
        return restObject;
    }

    public deserializeOrCreate<T extends TSSerializable<any>>(restObject: any, obj: T): T {
        if (restObject) {
            return obj.deserialize(restObject);
        } else {
            return obj;
        }
    }

    public deserializeOrNull<T extends TSSerializable<any>>(restObject: any, obj: T): T | undefined {
        if (restObject) {
            return obj.deserialize(restObject);
        } else {
            return undefined;
        }
    }

    public serializeOrInit(object: TSSerializable<any> | undefined, restObject: any) {
        if (object) {
            return object.serialize({});
        } else {
            return undefined;
        }
    }

    public arrayToRestObject(array?: Array<TSSerializable<any>>): Array<any> {
        let list: any[] = [];
        if (array) {
            for (let i = 0; i < array.length; i++) {
                list[i] = this.serializeOrInit(array[i], list[i]);
            }
        }
        return list;
    }

    public isEmptyString(str: string | undefined): boolean {
        return (!str || 0 === str.length);
    }

    public getOptionalString(str: string | undefined): string | undefined {
        if (this.isEmptyString(str)) {
            return undefined;
        }

        return str;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSAbstractEntity.ts